// extracted by mini-css-extract-plugin
export var cardIcon = "_1d-5";
export var cardIconUnframed = "_1d-9";
export var checkboxCard = "_1d-0";
export var checkboxCardSelected = "_1d-4";
export var disabled = "_1d-2";
export var interactive = "_1d-1";
export var outerBorder = "_1d-3";
export var spacerMedium = "_1d-8";
export var spacerSmall = "_1d-7";
export var spacerXsmall = "_1d-6";